<template>
    <standard-modal
        name="cookie-modal"
        action="/"
        :title="lang('Cookies och data', 'Cookies and data')"
        :show-close-button="false"
        :open-on-page-load="show"
        :width="740"
    >
        <!-- eslint-disable vue/no-v-html -->
        <div class="cookie-modal-text" v-html="translation('cookie_bar_text')" />

        <div class="flex flex-col-reverse lg:flex-row justify-between mt-3xl">
            <button
                class="btn btn-md is-primary bg-accent-dark mt-md lg:mt-0"
                @click="$modal.show('cookie-settings-modal')"
            >
                {{ lang('Ändra inställningar', 'Modify settings') }}
            </button>
            <button
                type="button"
                class="btn btn-md is-primary bg-accent-dark mt-md lg:mt-0"
                @click="onlyNecessary"
            >
                {{ lang('Endast nödvändiga', 'Only required') }}
            </button>
            <button
                type="button"
                class="btn btn-md is-primary bg-accent-dark"
                @click="approve"
            >
                {{ lang('Jag godkänner', 'I approve') }}
            </button>
        </div>
        <cookie-settings-modal
            :cookie-policies="cookiePolicies"
            :permissions="parseInt($cookies.get(cookieKey))"
            @save="setTrackingPermissions"
        />
    </standard-modal>
</template>
<script>
    import CookieSettingsModal from './CookieSettingsModal';

    export default {
        components: {
            CookieSettingsModal,
        },
        props: {
            cookieKey: {
                type: String,
                required: true,
            },
            cookiePolicies: {
                type: Object,
                required: true,
            },
            necessaryPolicy: {
                type: Number,
                required: true,
            },
        },
        computed: {
            show() {
                return this.$cookies.get(this.cookieKey) === null;
            },
        },
        methods: {
            approve() {
                this.setTrackingPermissions(this.getFullPermissions());
            },
            onlyNecessary() {
                this.setTrackingPermissions(this.necessaryPolicy);
            },
            setTrackingPermissions(permissions) {
                this.$cookies.set(this.cookieKey, permissions, Infinity);
                this.$GtmTracker.cookiePolicyApproved();
                window.location.reload();
            },
            getFullPermissions() {
                return Object
                    .values(this.cookiePolicies)
                    .reduce((total, policy) => total + policy.bitmask, 0);
            },
        },
    };
</script>

<style scoped>
    .cookie-modal-text >>> a {
        @apply .font-semibold .text-accent-blue;
    }

    .cookie-modal-text >>> a:hover {
        @apply .text-accent-blue-darker .underline;
    }
</style>
